import fetch from './fetch'

export function getAnnouncements (): Promise<api.announcement.GetAnnouncementsResponse> {
  return fetch.get('/announcements').then(res => res.data)
}
